import {TagBehaviorsEnum} from './tagModel';

export enum TagBulkActionTypesEnum {
  DELETE = 'DELETE',
  NEST_UNDER = 'NEST_UNDER',
  ARCHIVE = 'ARCHIVE',
  RESTORE = 'RESTORE',
}

interface TagBulkActionBase {
  namespace: string;
}

interface TagBulkActionWithSelectedTags extends TagBulkActionBase {
  selectedTagIds: ReadonlyArray<number>;
  searchTerm?: never;
  searchOptions?: never;
}

interface TagBulkActionWithSearch extends TagBulkActionBase {
  searchTerm: string;
  searchOptions: {
    excludeTagIds: ReadonlyArray<number>;
    behaviors: ReadonlyArray<TagBehaviorsEnum>;
    parentTagId: number | undefined;
    isArchived: boolean;
  };
  selectedTagIds?: never;
}

type TagBulkActionMeans = TagBulkActionWithSelectedTags | TagBulkActionWithSearch;

type TagBulkActionDelete = TagBulkActionMeans & {
  type: TagBulkActionTypesEnum.DELETE;
};

type TagBulkActionNest = TagBulkActionMeans & {
  type: TagBulkActionTypesEnum.NEST_UNDER;
  parentTagId: number | undefined;
};

type TagBulkActionArchive = TagBulkActionMeans & {
  type: TagBulkActionTypesEnum.ARCHIVE;
};

type TagBulkActionRestore = TagBulkActionMeans & {
  type: TagBulkActionTypesEnum.RESTORE;
};

export type TagBulkActionTemplate =
  | TagBulkActionDelete
  | TagBulkActionNest
  | TagBulkActionArchive
  | TagBulkActionRestore;

export function serializeTagBulkActionTemplate(payload: TagBulkActionTemplate, userId: number) {
  return {
    action: payload.type,
    requester_id: userId,
    namespace: payload.namespace,
    selected_tag_ids: payload.selectedTagIds,
    search_term: payload.searchTerm,
    search_options: payload.searchOptions
      ? {
          exclude_tag_ids: payload.searchOptions.excludeTagIds,
          behaviors: payload.searchOptions.behaviors,
          parent_tag_id: payload.searchOptions.parentTagId,
          is_archived: payload.searchOptions.isArchived,
        }
      : undefined,
    parent_tag_id: payload.type === TagBulkActionTypesEnum.NEST_UNDER ? payload.parentTagId : undefined,
  };
}
